// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 1056px) {
  .filter-btn {
    display: flex;
    justify-content: space-between;
  }
  .filter-btn-mob {
    height: 34px !important;
  }
  .mob-fab {
    display: none !important;
  }
  .fixed-button {
    display: none;
  }
}
@media only screen and (max-width: 1224px) {
  .filter-btn-mob {
    display: none !important;
  }
  .fixed-button {
    display: block !important;
    position: fixed;
    bottom: 40px; /* Adjust this value to change the distance from the bottom */
    right: 20px; /* Adjust this value to change the distance from the right */
    z-index: 9999; /* Ensure the button appears above other elements */
    color: #fff;
    padding: 15px 20px;
    border-radius: 50%;
    cursor: pointer;
  }
}
@media only screen and (min-width: 899px) {
  .fixed-filter {
    position: sticky;
    top: 10px;
  }
}
@media only screen and (max-width: 1056px) {
  .fixed-button {
    position: fixed;
    bottom: 40px; /* Adjust this value to change the distance from the bottom */
    right: 20px; /* Adjust this value to change the distance from the right */
    z-index: 9999; /* Ensure the button appears above other elements */
    color: #fff;
    padding: 15px 20px;
    border-radius: 50%;
    cursor: pointer;
  }
}
@media (max-width: 1214px) {
  .margin-end {
    margin-right: 16px;
  }
}
.css-15v19k8-MuiTabs-indicator {
  background-color: #674bff !important;
}

.css-102r8cn-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #674bff !important;
}

.css-wtlhl5-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #ffffff !important;
}

.m-top {
  margin-top: 12px !important;
}

.nowrap-text {
  white-space: nowrap;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.example1::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.example1 {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

@media only screen and (max-width: 600px) {
  .MuiTabs-scroller.MuiTabs-fixed.css-jpln7h-MuiTabs-scroller {
    overflow: hidden;
    margin-bottom: -12px !important;
  }
}
@media only screen and (min-width: 600px) {
  .MuiTabs-scroller.MuiTabs-fixed.css-jpln7h-MuiTabs-scroller {
    overflow: hidden;
    margin-bottom: -24px !important;
  }
}
@media only screen and (min-width: 600px) {
  .css-v0v7vh-MuiTabs-root {
    overflow: hidden;
    min-height: 54px !important;
  }
}
@media only screen and (max-width: 600px) {
  .css-heg063-MuiTabs-flexContainer {
    overflow-x: scroll !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/organaization/organization-activity-details/profile-details.scss"],"names":[],"mappings":"AAAA;EACE;IACE,aAAA;IACA,8BAAA;EACF;EACA;IACE,uBAAA;EACF;EACA;IACE,wBAAA;EACF;EACA;IACE,aAAA;EACF;AACF;AACA;EACE;IACE,wBAAA;EACF;EACA;IACE,yBAAA;IACA,eAAA;IACA,YAAA,EAAA,6DAAA;IACA,WAAA,EAAA,4DAAA;IACA,aAAA,EAAA,mDAAA;IACA,WAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EACF;AACF;AACA;EACE;IACE,gBAAA;IACA,SAAA;EACF;AACF;AACA;EACE;IACE,eAAA;IACA,YAAA,EAAA,6DAAA;IACA,WAAA,EAAA,4DAAA;IACA,aAAA,EAAA,mDAAA;IACA,WAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EACF;AACF;AAEA;EACE;IACE,kBAAA;EAAF;AACF;AAEA;EACE,oCAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,2BAAA;AAGF;;AADA;EACE,mBAAA;AAIF;;AADA,gDAAA;AACA;EACE,aAAA;AAIF;;AADA,4CAAA;AACA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAIF;;AAFA;EACE;IACE,gBAAA;IACA,+BAAA;EAKF;AACF;AAHA;EACE;IACE,gBAAA;IACA,+BAAA;EAKF;AACF;AAHA;EACE;IACE,gBAAA;IACA,2BAAA;EAKF;AACF;AAFA;EACE;IACE,6BAAA;EAIF;AACF","sourcesContent":["@media only screen and (min-width: 1056px) {\n  .filter-btn {\n    display: flex;\n    justify-content: space-between;\n  }\n  .filter-btn-mob {\n    height: 34px !important;\n  }\n  .mob-fab {\n    display: none !important;\n  }\n  .fixed-button {\n    display: none;\n  }\n}\n@media only screen and (max-width: 1224px) {\n  .filter-btn-mob {\n    display: none !important;\n  }\n  .fixed-button {\n    display: block !important;\n    position: fixed;\n    bottom: 40px; /* Adjust this value to change the distance from the bottom */\n    right: 20px; /* Adjust this value to change the distance from the right */\n    z-index: 9999; /* Ensure the button appears above other elements */\n    color: #fff;\n    padding: 15px 20px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n}\n@media only screen and (min-width: 899px) {\n  .fixed-filter {\n    position: sticky;\n    top: 10px;\n  }\n}\n@media only screen and (max-width: 1056px) {\n  .fixed-button {\n    position: fixed;\n    bottom: 40px; /* Adjust this value to change the distance from the bottom */\n    right: 20px; /* Adjust this value to change the distance from the right */\n    z-index: 9999; /* Ensure the button appears above other elements */\n    color: #fff;\n    padding: 15px 20px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: 1214px) {\n  .margin-end {\n    margin-right: 16px;\n  }\n}\n.css-15v19k8-MuiTabs-indicator {\n  background-color: #674bff !important;\n}\n.css-102r8cn-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #674bff !important;\n}\n.css-wtlhl5-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #ffffff !important;\n}\n.m-top {\n  margin-top: 12px !important;\n}\n.nowrap-text {\n  white-space: nowrap;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.example1::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.example1 {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n@media only screen and (max-width: 600px) {\n  .MuiTabs-scroller.MuiTabs-fixed.css-jpln7h-MuiTabs-scroller {\n    overflow: hidden;\n    margin-bottom: -12px !important;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .MuiTabs-scroller.MuiTabs-fixed.css-jpln7h-MuiTabs-scroller {\n    overflow: hidden;\n    margin-bottom: -24px !important;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .css-v0v7vh-MuiTabs-root {\n    overflow: hidden;\n    min-height: 54px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .css-heg063-MuiTabs-flexContainer {\n    overflow-x: scroll !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
